/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BookingTenantApiResource,
  NotFoundErrorResponse,
  PostApiBookingTenantUpdate200,
  UnauthorizedErrorResponse,
  UpdateBookingTenantRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiBookingTenantGetResponse200 = {
  data: BookingTenantApiResource
  status: 200
}

export type getApiBookingTenantGetResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBookingTenantGetResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiBookingTenantGetResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiBookingTenantGetResponseSuccess = (getApiBookingTenantGetResponse200) & {
  headers: Headers;
};
export type getApiBookingTenantGetResponseError = (getApiBookingTenantGetResponse401 | getApiBookingTenantGetResponse403 | getApiBookingTenantGetResponse404) & {
  headers: Headers;
};

export type getApiBookingTenantGetResponse = (getApiBookingTenantGetResponseSuccess | getApiBookingTenantGetResponseError)

export const getGetApiBookingTenantGetUrl = (id: number,) => {


  

  return `/api/bookings-tenants/${id}`
}

export const getApiBookingTenantGet = async (id: number, options?: RequestInit): Promise<getApiBookingTenantGetResponse> => {
  
  return customFetch<getApiBookingTenantGetResponse>(getGetApiBookingTenantGetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiBookingTenantSyncResponse200 = {
  data: BookingTenantApiResource
  status: 200
}

export type postApiBookingTenantSyncResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBookingTenantSyncResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiBookingTenantSyncResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiBookingTenantSyncResponseSuccess = (postApiBookingTenantSyncResponse200) & {
  headers: Headers;
};
export type postApiBookingTenantSyncResponseError = (postApiBookingTenantSyncResponse401 | postApiBookingTenantSyncResponse403 | postApiBookingTenantSyncResponse404) & {
  headers: Headers;
};

export type postApiBookingTenantSyncResponse = (postApiBookingTenantSyncResponseSuccess | postApiBookingTenantSyncResponseError)

export const getPostApiBookingTenantSyncUrl = (id: number,) => {


  

  return `/api/bookings-tenants/${id}/sync`
}

export const postApiBookingTenantSync = async (id: number, options?: RequestInit): Promise<postApiBookingTenantSyncResponse> => {
  
  return customFetch<postApiBookingTenantSyncResponse>(getPostApiBookingTenantSyncUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


export type postApiBookingTenantUpdateResponse200 = {
  data: PostApiBookingTenantUpdate200
  status: 200
}

export type postApiBookingTenantUpdateResponse400 = {
  data: void
  status: 400
}

export type postApiBookingTenantUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBookingTenantUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiBookingTenantUpdateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiBookingTenantUpdateResponseSuccess = (postApiBookingTenantUpdateResponse200) & {
  headers: Headers;
};
export type postApiBookingTenantUpdateResponseError = (postApiBookingTenantUpdateResponse400 | postApiBookingTenantUpdateResponse401 | postApiBookingTenantUpdateResponse403 | postApiBookingTenantUpdateResponse404) & {
  headers: Headers;
};

export type postApiBookingTenantUpdateResponse = (postApiBookingTenantUpdateResponseSuccess | postApiBookingTenantUpdateResponseError)

export const getPostApiBookingTenantUpdateUrl = (id: number,) => {


  

  return `/api/booking-tenants/${id}/update`
}

export const postApiBookingTenantUpdate = async (id: number,
    updateBookingTenantRequest: UpdateBookingTenantRequest, options?: RequestInit): Promise<postApiBookingTenantUpdateResponse> => {
  
  return customFetch<postApiBookingTenantUpdateResponse>(getPostApiBookingTenantUpdateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateBookingTenantRequest,)
  }
);}


